import styled from "styled-components";

export const AmenitiesWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-around;
  width: 100%;
  column-gap: 20px;
  p {
    margin: 0;
    width: 160px;
  }

  .ant-collapse-header {
    font-family: "Open Sans", "sans-serif";
    text-transform: uppercase;
    border: 0px;
  }

  .ant-collapse {
    border: 0px;
  }

  // text inside accordion
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    color: black;
  }
`;
